// extracted by mini-css-extract-plugin
export default {"searchWidget":"searchWidget-module--searchWidget--uf98K","input":"searchWidget-module--input--2dSzN","button":"searchWidget-module--button--2yt92"};